import { render, staticRenderFns } from "./Wol.vue?vue&type=template&id=f532a878&"
import script from "./Wol.vue?vue&type=script&lang=js&"
export * from "./Wol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports